export default "__VITE_ASSET__CNFQBW38__"